import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ToastModule } from '@shared/components/toast';

import { DynamicReportGeneralEditComponent } from './dynamic-report-general-edit.component';
import { DynamicReportGeneralFormModule } from '../dynamic-report-general-form/dynamic-report-general-form.module';
import { DynamicReportGeneralEditRoutingModule } from './dynamic-report-general-edit-routing.module';
import { PermissionModule } from '@shared/permission';
import { DynamicReportGeneralPreviewModule } from '../dynamic-report-general-preview/dynamic-report-general-preview.module';

const angularMaterialModules = [
    MatIconModule,
    MatButtonModule
];

@NgModule({
    declarations: [
        DynamicReportGeneralEditComponent
    ],
    imports: [
        CommonModule,
        ...angularMaterialModules,
        DynamicReportGeneralEditRoutingModule,
        DynamicReportGeneralFormModule,
        PermissionModule,
        ToastModule,
        DynamicReportGeneralPreviewModule
    ]
})
export class DynamicReportGeneralEditModule { } 